import routerOptions0 from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.2_@azure+identity@4.13.0_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@b_9fbdec1ae8d1fe380d7267799a951312/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}